angular.module('surfsightApp.controllers').controller('reportController', [
  '$scope',
  '$rootScope',
  '$log',
  '$state',
  '$timeout',
  '$interval',
  '$location',
  '$http',
  '$filter',
  '$localStorage',
  '$mdDialog',
  '$mdMedia',
  '$mdSidenav',
  '$mdToast',
  '$mdColors',
  'edgeFactory',
  'edgeGroupFactory',
  'leafletData',
  'nominatimLookUp',
  '$stateParams',
  function (
    $scope,
    $rootScope,
    $log,
    $state,
    $timeout,
    $interval,
    $location,
    $http,
    $filter,
    $localStorage,
    $mdDialog,
    $mdMedia,
    $mdSidenav,
    $mdToast,
    $mdColors,
    edgeFactory,
    edgeGroupFactory,
    leafletData,
    nominatimLookUp,
    $stateParams
  ) {
    $scope.reportType = 1
    if ($stateParams.reportType) {
      $scope.reportType = $stateParams.reportType
    }
    if ($stateParams.eventSearch) {
      $scope.range = $stateParams.eventSearch
    }
    $scope.$on('reportType', function (e, data) {
      $scope.reportType = data.type
    })
    $scope.$on('aggressiveSearchDataEmit', function (e, data) {
      $scope.range = data.eventSearchData.response
    })
    $scope.$on('eventSearchDataResult', function (e, data) {
      $scope.range = data.eventSearchData.response
    })
    if (!$mdMedia('gt-sm')) {
      $scope.reportType = $stateParams.reportType
      if (!$scope.reportType) {
        $scope.reportType = 1
      }
    }
  }
])
